export default __webpack_public_path__ + "locales/bg/JavascriptSdk.json?hash=314fb2f25b08007b9ba637fd6a739971";